import { HttpClient, HttpMethods, RequestConfig } from "./types/httpClient";
import { Service } from "./types/service";

import { createLinker } from "./linkers";

import { getProject } from "./core/getProject";
import { getProjects } from "./core/getProjects";
import { getZonesIndicators } from "./core/getZonesIndicators";
import { getPlanzones } from "./core/getPlanzones";
import { getPlanzoneSettings } from "./core/getPlanzoneSettings";
import { updatePlanzoneSettings } from "./core/updatePlanzoneSettings";
import { getTasks } from "./core/retrieveTasks";
import { saveTask } from "./core/saveTask";
import { saveEvent } from "./core/saveEvent";
import { editTask } from "./core/editTask";
import { saveProject } from "./core/saveProject";
import { getZones } from "./core/getZones";
import { getZone } from "./core/getZone";
import { deleteZone } from "./core/deleteZone";
import { moveProjects } from "./core/moveProjects";
import { saveZone } from "./core/saveZone";
import { editZone } from "./core/editZone";
import { getZoneProjects } from "./core/getZoneProjects";
import { getZonesWithoutRLS } from "./core/getZonesWithoutRLS";
import { getLists } from "./core/getLists";
import { getResource } from "./core/getResource";
import { getProjectResources } from "./core/getProjectResources";
import { savePlanzone } from "./core/savePlanzone";
import { getTask } from "./core/getTask";
import { saveTaskStatus } from "./core/saveTaskStatus";
import { confirmAccountCreation } from "./uaa/confirmAccountCreation";
import { saveAccount } from "./uaa/saveAccount";
import { getTaskStatuses } from "./core/getTaskStatuses";
import { editUserPreferences } from "./uaa/editUserPreferences";
import { saveList } from "./core/saveList";
import { getProjectGantt } from "./core/getProjectGantt";
import { getResourceProjects } from "./core/getResourceProjects";
import { removeTask } from "./core/removeTask";
import { getRoles } from "./core/getRoles";
import { saveMaterialResourceInPlanzone } from "./core/saveMaterialResourceInPlanzone";
import { updateTaskStatus } from "./core/updateTaskStatus";
import { updateProject } from "./core/updateProject";
import { getList } from "./core/getList";
import { editList } from "./core/editList";
import { getUserPreferences } from "./uaa/getUserPreferences";
import { removeProject } from "./core/removeProject";
import { removeList } from "./core/removeList";
import { saveVirtualResourceInPlanzone } from "./core/saveVirtualResourceInPlanzone";
import { getPlanzoneResources } from "./core/getPlanzoneResources";
import { getPlanzoneResourcesListing } from "./core/getPlanzoneResourcesListing";
import { getPlanzoneResourcesCounts } from "./core/getPlanzoneResourcesCounts";
import { addPlanzoneResourceToProject } from "./core/addPlanzoneResourceToProject";
import { saveAllocation } from "./core/saveAllocation";
import { saveAllocations } from "./core/saveAllocations";
import { updateProjectWeatherReport } from "./core/updateProjectWeatherReport";
import { removeResourceFromProject } from "./core/removeResourceFromProject";
import { removeResourceFromProjectAndTransferAllocations } from "./core/removeResourceFromProjectAndTransferAllocations";
import { transferProjectResourceAllocations } from "./core/transferProjectResourceAllocations";
import { addTagToList } from "./core/addTagToList";
import { addTagToTask } from "./core/addTagToTask";
import { removeTaskStatus } from "./core/removeTaskStatus";
import { saveMilestone } from "./core/saveMilestone";
import { editAllocation } from "./core/editAllocation";
import { getKanban } from "./core/getKanban";
import { editMilestone } from "./core/editMilestone";
import { removeAllocation } from "./core/removeAllocation";
import { getUserHumanResource } from "./core/getUserHumanResource";
import { getMilestone } from "./core/getMilestone";
import { addTagToMilestone } from "./core/addTagToMilestone";
import { getPersonalSynthesis } from "./core/getPersonalSynthesis";
import { getProjectTasks } from "./core/getProjectTasks";
import { changePlanzone } from "./core/changePlanzone";
import { savePlanzoneLogo } from "./core/savePlanzoneLogo";
import { moveProjectElement } from "./core/moveProjectElement";
import { moveKanbanTask } from "./core/moveKanbanTask";
import { moveTask } from "./core/moveTask";
import { moveList } from "./core/moveList";
import { moveMilestone } from "./core/moveMilestone";
import { getCurrentPlanzone } from "./core/getCurrentPlanzone";
import { removeTagFromList } from "./core/removeTagFromList";
import { removeTagFromTask } from "./core/removeTagFromTask";
import { removeTagFromMilestone } from "./core/removeTagFromMilestone";
import { getProjectsElementsTags } from "./core/getProjectsElementsTags";
import { getProjectsTags } from "./core/getProjectsTags";
import { getResourcesTags } from "./core/getResourcesTags";
import { getProjectResourcesTags } from "./core/getProjectResourcesTags";
import { saveProjectExternalLink } from "./core/saveProjectExternalLink";
import { getProjectExternalLinks } from "./core/getProjectExternalLinks";
import { removeProjectExternalLink } from "./core/removeProjectExternalLink";
import { editProjectExternalLink } from "./core/editProjectExternalLink";
import { getProjectStatuses } from "./core/getProjectStatuses";
import { saveProjectStatus } from "./core/saveProjectStatus";
import { updateProjectStatus } from "./core/updateProjectStatus";
import { removeProjectStatus } from "./core/removeProjectStatus";
import { saveResourceInProject } from "./core/saveResourceInProject";
import { saveResourcesInProject } from "./core/saveResourcesInProject";
import { saveResourceInProjects } from "./core/saveResourceInProjects";
import { saveProjectResource } from "./core/saveProjectResource";
import { removeResourceFromPlanzone } from "./core/removeResourceFromPlanzone";
import { saveProfilePicture } from "./core/saveProfilePicture";
import { removeResourceFromPlanzoneAndTransferAllocations } from "./core/removeResourceFromPlanzoneAndTransferAllocations";
import { getCalendar } from "./core/getCalendar";
import { getPersonalWeeklyCalendar } from "./core/getPersonalWeeklyCalendar";
import { editPersonalWeeklyCalendar } from "./core/editPersonalWeeklyCalendar";
import { editResourceWeeklyCalendar } from "./core/editResourceWeeklyCalendar";
import { editProjectReportTemplate } from "./core/editProjectReportTemplate";
import { getProjectReportTemplate } from "./core/getProjectReportTemplate";
import { saveProjectReport } from "./core/saveProjectReport";
import { updateProjectReport } from "./core/updateProjectReport";
import { getProjectReports } from "./core/getProjectReports";
import { updateProjectConfiguration } from "./core/updateProjectConfiguration";
import { getProjectConfiguration } from "./core/getProjectConfiguration";
import { editResource } from "./core/editResource";
import { updatePlanzoneContacts } from "./core/updatePlanzoneContacts";
import { getPlanzoneRole } from "./core/getPlanzoneRole";
import { getZoneRole } from "./core/getZoneRole";
import { getProjectRole } from "./core/getProjectRole";
import { getProjectsRoles } from "./core/getProjectsRoles";
import { editResourceGroup } from "./core/editResourceGroup";
import { getResourceGroup } from "./core/getResourceGroup";
import { getResourceGroups } from "./core/getResourceGroups";
import { removeResourceGroup } from "./core/removeResourceGroup";
import { saveResourceGroup } from "./core/saveResourceGroup";
import { saveResourceInResourceGroup } from "./core/saveResourceInResourceGroup";
import { removeResourceFromResourceGroup } from "./core/removeResourceFromResourceGroup";
import { editProjectResource } from "./core/editProjectResource";
import { addTagToProject } from "./core/addTagToProject";
import { removeTagFromProject } from "./core/removeTagFromProject";
import { removeMilestone } from "./core/removeMilestone";
import { getEvent } from "./core/getEvent";
import { editEvent } from "./core/editEvent";
import { removeEvent } from "./core/removeEvent";
import { addTagToResource } from "./core/addTagToResource";
import { removeTagFromResource } from "./core/removeTagFromResource";
import { addTagToEvent } from "./core/addTagToEvent";
import { removeTagFromEvent } from "./core/removeTagFromEvent";
import { updateOrganization } from "./core/updateOrganization";
import { getPlanzoneOrganisation } from "./core/getPlanzoneOrganisation";
import { getDiscussion } from "./core/getDiscussion";
import { saveComment } from "./core/saveComment";
import { createDiscussion as addDiscussion } from "./core/createDiscussion";
import { removeDiscussion } from "./core/removeDiscussion";
import { removeComment } from "./core/removeComment";
import { getDiscussions } from "./core/getDiscussions";
import { getProjectPortfolios } from "./core/getProjectPortfolios";
import { saveProjectPortfolio } from "./core/saveProjectPortfolio";
import { isProjectPortfolioDuplicate } from "./core/isProjectPortfolioDuplicate";
import { saveProjectInPortfolio } from "./core/saveProjectInPortfolio";
import { removeProjectPortfolio } from "./core/removeProjectPortfolio";
import { removeProjectFromPortfolio } from "./core/removeProjectFromPortfolio";
import { updateProjectPortfolio } from "./core/updateProjectPortfolio";
import { getProjectModels } from "./core/getProjectModels";
import { duplicateProjectFromModel } from "./core/duplicateProjectFromModel";
import { duplicateProject } from "./core/duplicateProject";
import { duplicateModelFromProject } from "./core/duplicateModelFromProject";
import { editPassword } from "./uaa/editPassword";
import { createDiscussion } from "./afterEffects/createDiscussion";
import { getZoneResources } from "./core/getZoneResources";
import { sendInvitation } from "./core/sendInvitation";
import { getNotifications } from "./core/getNotifications";
import { fillAccount } from "./core/fillAccount";
import { moveEvent } from "./core/moveEvent";
import { getUnReadNotificationsNbr } from "./core/getUnReadNotificationsNbr";
import { editNotificationsStatus } from "./core/editNotificationsStatus";
import { removeProjectReport } from "./core/removeProjectReport";
import { sendActivityReport } from "./core/sendActivityReport";
import { getProjectSynthesis } from "./core/getProjectSynthesis";
import { getProjectTimeSheet } from "./core/getProjectTimeSheet";
import { getTimeSheet } from "./core/getTimeSheet";
import { reloadProjectTimeSheet } from "./core/reloadProjectTimeSheet";
import { getOptimizedTimeSheet } from "./core/getOptimizedTimeSheet";
import { saveTimeRecord } from "./core/saveTimeRecord";
import { getWeekTimeRecords } from "./core/getWeekTimeRecords";
import { deleteTimeRecord } from "./core/deleteTimeRecord";
import { validateTimeRecords } from "./core/validateTimeRecords";
import { getProjectBudgetSynthesis } from "./core/getProjectBudgetSynthesis";
import { saveCostProfile } from "./core/saveCostProfile";
import { getCostProfiles } from "./core/getCostProfiles";
import { updateCostProfile } from "./core/updateCostProfile";
import { removeCostProfile } from "./core/removeCostProfile";
import { saveCostProfileAssignation } from "./core/saveCostProfileAssignation";
import { removeCostProfileAssignation } from "./core/removeCostProfileAssignation";
import { getWorkLoads } from "./core/getWorkLoads";
import { getCapacity } from "./core/getCapacity";
import { getWorkload } from "./core/getWorkload";
import { getWorkloadProjects } from "./core/getWorkloadProjects";
import { getOccupancy } from "./core/getOccupancy";
import { adjustWorkload } from "./core/adjustWorkload";
import { adjustCapacity } from "./core/adjustCapacity";
import { getCostProfileCostsHistory } from "./core/getCostProfileCostsHistory";
import { removeCost } from "./core/removeCost";
import { updateCost } from "./core/updateCost";
import { updateProjectAllocatedBudget } from "./core/updateProjectAllocatedBudget";
import { updateProjectAllocatedResourcesBudget } from "./core/updateProjectAllocatedResourcesBudget";
import { updateProjectAllocatedExpensesBudget } from "./core/updateProjectAllocatedExpensesBudget";
import { getPersonalTimeSheet } from "./core/getPersonalTimeSheet";
import { validatePersonalTimeRecords } from "./core/validatePersonalTimeRecords";
import { saveConstraint } from "./core/saveConstraint";
import { updateConstraint } from "./core/updateConstraint";
import { removeConstraint } from "./core/removeConstraint";
import { getElementConstraints } from "./core/getElementConstraints";
import { getConstraint } from "./core/getConstraint";
import { getAccessRestrictions } from "./core/getAccessRestrictions";
import { updateAccessRestrictions } from "./core/updateAccessRestrictions";
import { saveIdentityProvider } from "./core/saveIdentityProvider";
import { getIdentityProviders } from "./core/getIdentityProviders";
import { removeIdentityProvider } from "./core/removeIdentityProvider";
import { updateIdentityProvider } from "./core/updateIdentityProvider";
import { getOptimizedGantt } from "./core/getOptimizedGantt";
import { getGanttCalendarRange } from "./core/getGanttCalendarRange";
import { getWbsMeta } from "./core/getWbsMeta";
import { getConstraints } from "./core/getConstraints";

import { getDocuments } from "./documents/getDocuments";
import { saveDocument } from "./documents/saveDocument";
import { retrieveDocumentKey } from "./documents/retrieveDocumentKey";
import { saveFolder } from "./documents/saveFolder";
import { updateFolder } from "./documents/updateFolder";
import { removeFolder } from "./documents/removeFolder";
import { removeDocument } from "./documents/removeDocument";
import { attachDocumentsToElement } from "./documents/attachDocumentsToElement";
import { removeAttachedDocument } from "./documents/removeAttachedDocument";
import { retrieveElementAttachments } from "./documents/retrieveElementAttachments";
import { moveDocument } from "./documents/moveDocument";
import { getDocumentTemplatesFolder } from "./documents/getDocumentTemplatesFolder";
import { createDocument } from "./documents/createDocument";
import { getDocumentEditionToken } from "./documents/getDocumentEditionToken";
import { copyDocument } from "./documents/copyDocument";
import { updateDocument } from "./documents/updateDocument";
import { getPrivateDocuments } from "./documents/getPrivateDocuments";
import { moveFolder } from "./documents/moveFolder";

import { getStrategicAxes } from "./core/getStrategicAxes";
import { saveStrategicAxis } from "./core/saveStrategicAxis";
import { getOrganizationalUnits } from "./core/getOrganizationalUnits";
import { getAllOrganizationalUnits } from "./core/getAllOrganizationalUnits";
import { saveOrganizationalUnit } from "./core/saveOrganizationalUnit";
import { editOrganizationalUnit } from "./core/editOrganizationalUnit";
import { removeOrganizationalUnit } from "./core/removeOrganizationalUnit";
import { moveOrganizationalUnit } from "./core/moveOrganizationalUnit";
import { assignResourcesToOrganizationalUnit } from "./core/assignResourcesToOrganizationalUnit";
import { unassignResourcesFromOrganizationalUnit } from "./core/unassignResourcesFromOrganizationalUnit";
import { removeStrategicAxis } from "./core/removeStrategicAxis";
import { editStrategicAxis } from "./core/editStrategicAxis";
import { saveProjectStrategicAxis } from "./core/saveProjectStrategicAxis";
import { getProjectStrategicAxes } from "./core/getProjectStrategicAxes";
import { editProjectStrategicAxis } from "./core/editProjectStrategicAxis";
import { getGantt } from "./core/getGantt";
import { getZoneGantt } from "./core/getZoneGantt";
import { duplicateList } from "./core/duplicateList";

import { saveUnavailability } from "./core/saveUnavailability";
import { updateUnavailability } from "./core/updateUnavailability";
import { removeUnavailability } from "./core/removeUnavailability";
import { getUnavailabilityReasons } from "./core/getUnavailabilityReasons";
import { getUnavailabilities } from "./core/getUnavailabilities";

import { saveCalendarExportLink } from "./core/saveCalendarExportLink";
import { getCalendarExportLinks } from "./core/getCalendarExportLinks";
import { saveExportBiRun } from "./core/saveExportBiRun";
import { getExportBiRun } from "./core/getExportBiRun";

import { saveVideoConferenceCall } from "./core/saveVideoConferenceCall";
import { getVideoConferenceCallLinks } from "./core/getVideoConferenceCallLinks";
import { assignManagerToResource } from "./core/assignManagerToResource";
import { getResourceSubordinates } from "./core/getResourceSubordinates";
import { getProjectResourcesListing } from "./core/getProjectResourcesListing";
import { unAssignManagerFromResource } from "./core/unAssignResourceFromManager";
import { assignEveryoneToManager } from "./core/assignEveryoneToManager";
import { removeSubordinates } from "./core/removeSubordinates";
import { saveEveryoneInProject } from "./core/saveEveryoneInProject";
import { saveEveryoneInResourceGroup } from "./core/saveEveryoneInResourceGroup";

import { getProjectExpenses } from "./core/getProjectExpenses";
import { saveProjectExpense } from "./core/saveProjectExpense";
import { getProjectExpenseTypes } from "./core/getProjectExpenseTypes";
import { saveProjectExpenseType } from "./core/saveProjectExpenseType";
import { removeProjectExpense } from "./core/removeProjectExpense";
import { editProjectExpense } from "./core/editProjectExpense";
import { getProjectLogs } from "./core/getProjectLogs";
import { saveCalendarHolidays } from "./core/saveCalendarHolidays";
import { getCalendarsHolidays } from "./core/getCalendarsHolidays";
import { removeCalendarHolidays } from "./core/removeCalendarHolidays";
import { editCalendarHolidays } from "./core/editCalendarHolidays";
import { removeHoliday } from "./core/removeHoliday";
import { assignPersonalCalendarHolidays } from "./core/assignPersonalCalendarHolidays";
import { getPersonalCalendarHolidays } from "./core/getPersonalCalendarHolidays";
import { getResourceCalendarHolidays } from "./core/getResourceCalendarHolidays";
import { assignDefaultCalendarHolidaysToPlanzone } from "./core/assignDefaultCalendarHolidaysToPlanzone";
import { getDefaultCalendarHolidays } from "./core/getDefaultCalendarHolidays";
import { assignCalendarHolidaysToRessource } from "./core/assignCalendarHolidaysToResource";
import { unAssignCalendarHolidaysFromResource } from "./core/unAssignCalendarHolidaysFromResource";
import { unAssignPersonalCalendarHolidays } from "./core/unAssignPersonalCalendarHolidays";
import { editTimesheetDeadline } from "./core/editTimesheetDeadline";
import { updateAllocationWarningConfig } from "./core/updateAllocationWarningConfig";
import { checkAllocationWarnings } from "./core/checkAllocationWarnings";

import { getSecondaryCriteriaTemplate } from "./core/getSecondaryCriteriaTemplate";
import { updateSecondaryCriteriaTemplate } from "./core/updateSecondaryCriteriaTemplate";
import { getWbsConfiguration } from "./core/getWbsConfiguration";
import { updateWbsConfiguration } from "./core/updateWbsConfiguration";
import { getProjectDetailsConfiguration } from "./core/getProjectDetailsConfiguration";
import { updateProjectDetailsConfiguration } from "./core/updateProjectDetailsConfiguration";
import { getProjectListingConfiguration } from "./core/getProjectListingConfiguration";
import { updateProjectListingConfiguration } from "./core/updateProjectListingConfiguration";
import { getResourcesListingConfiguration } from "./core/getResourcesListingConfiguration";
import { updateResourcesListingConfiguration } from "./core/updateResourcesListingConfiguration";
import { getTimeRecordsListingConfiguration } from "./core/getTimeRecordsListingConfiguration";
import { updateTimeRecordsListingConfiguration } from "./core/updateTimeRecordsListingConfiguration";
import { getProjectMembersListingConfiguration } from "./core/getProjectMembersListingConfiguration";
import { updateProjectMembersListingConfiguration } from "./core/updateProjectMembersListingConfiguration";
import { getProjectElementDetailsConfiguration } from "./core/getProjectElementDetailsConfiguration";
import { updateProjectElementDetailsConfiguration } from "./core/updateProjectElementDetailsConfiguration";
import { getResourceDetailsConfiguration } from "./core/getResourceDetailsConfiguration";
import { updateResourceDetailsConfiguration } from "./core/updateResourceDetailsConfiguration";

import { disableProjectResource } from "./core/disableProjectResource";
import { activateProjectResource } from "./core/activateProjectResource";
import { disableResource } from "./core/disableResource";
import { activateResource } from "./core/activateResource";
import { getProjectResourceAllocations } from "./core/getProjectResourceAllocations";

import { getPlanzoneLogs } from "./core/getPlanzoneLogs";

import { submitChatJob } from "./chatbot/submitChatJob";
import { getChatConversations } from "./chatbot/getChatConversations";
import { getChatConversationMessages } from "./chatbot/getChatConversationMessages";
import { removeChatConversation } from "./chatbot/removeChatConversation";
import { cancelChatJob } from "./chatbot/cancelChatJob";
import { resetChatMemory } from "./chatbot/resetChatMemory";

function createService(
  apiHttpClient: HttpClient,
  uaaHttpClient: HttpClient,
  documentHttpClient: HttpClient,
  aiHttpClient: HttpClient,
): Service {
  const linker = createLinker(apiHttpClient);

  return {
    getProject: getProject(apiHttpClient, linker),
    getProjects: getProjects(apiHttpClient, linker),
    getZonesIndicators: getZonesIndicators(apiHttpClient),
    getPlanzones: getPlanzones(apiHttpClient),
    saveTask: (list, task) =>
      createDiscussion(apiHttpClient, () =>
        saveTask(apiHttpClient, linker)(list, task),
      )("tasks"),
    editTask: editTask(apiHttpClient, linker),
    saveProject: saveProject(apiHttpClient, linker),
    getZones: getZones(apiHttpClient),
    getZonesWithoutRLS: getZonesWithoutRLS(apiHttpClient),
    getZone: getZone(apiHttpClient),
    deleteZone: deleteZone(apiHttpClient),
    moveProjects: moveProjects(apiHttpClient),
    saveZone: saveZone(apiHttpClient, linker),
    editZone: editZone(apiHttpClient),
    getZoneProjects: getZoneProjects(apiHttpClient, linker),
    getLists: getLists(apiHttpClient, linker),
    getResource: getResource(apiHttpClient, linker),
    getProjectResources: getProjectResources(apiHttpClient, linker),
    saveAccount: saveAccount(uaaHttpClient),
    confirmAccountCreation: confirmAccountCreation(uaaHttpClient),
    savePlanzone: savePlanzone(apiHttpClient),
    getTask: getTask(apiHttpClient, linker),
    saveTaskStatus: saveTaskStatus(apiHttpClient),
    getTaskStatuses: getTaskStatuses(apiHttpClient),
    editUserPreferences: editUserPreferences(uaaHttpClient),
    saveList: (project, list) =>
      createDiscussion(apiHttpClient, () =>
        saveList(apiHttpClient, linker)(project, list),
      )("lists"),
    getProjectGantt: getProjectGantt(apiHttpClient, linker),
    removeTask: removeTask(apiHttpClient),
    getRoles: getRoles(apiHttpClient),
    saveMaterialResourceInPlanzone: saveMaterialResourceInPlanzone(
      apiHttpClient,
      linker,
    ),
    saveVirtualResourceInPlanzone: saveVirtualResourceInPlanzone(
      apiHttpClient,
      linker,
    ),
    updateTaskStatus: updateTaskStatus(apiHttpClient),
    getUserPreferences: getUserPreferences(uaaHttpClient),
    updateProject: updateProject(apiHttpClient, linker),
    removeProject: removeProject(apiHttpClient),
    editList: editList(apiHttpClient, linker),
    getList: getList(apiHttpClient, linker),
    removeList: removeList(apiHttpClient),
    getPlanzoneResources: getPlanzoneResources(apiHttpClient, linker),
    getPlanzoneResourcesListing: getPlanzoneResourcesListing(apiHttpClient),
    getPlanzoneResourcesCounts: getPlanzoneResourcesCounts(apiHttpClient),
    getZoneResources: getZoneResources(apiHttpClient, linker),
    addPlanzoneResourceToProject: addPlanzoneResourceToProject(
      apiHttpClient,
      linker,
    ),
    saveAllocation: saveAllocation(apiHttpClient),
    saveAllocations: saveAllocations(apiHttpClient),
    updateProjectWeatherReport: updateProjectWeatherReport(apiHttpClient),
    removeResourceFromProject: removeResourceFromProject(apiHttpClient),
    removeResourceFromProjectAndTransferAllocations:
      removeResourceFromProjectAndTransferAllocations(apiHttpClient),
    transferProjectResourceAllocations:
      transferProjectResourceAllocations(apiHttpClient),
    addTagToList: addTagToList(apiHttpClient),
    addTagToTask: addTagToTask(apiHttpClient),
    removeTaskStatus: removeTaskStatus(apiHttpClient),
    saveMilestone: (list, milestone) =>
      createDiscussion(apiHttpClient, () =>
        saveMilestone(apiHttpClient)(list, milestone),
      )("milestones"),
    change: changePlanzone(apiHttpClient),
    savePlanzoneLogo: savePlanzoneLogo(apiHttpClient, documentHttpClient),
    editAllocation: editAllocation(apiHttpClient),
    getKanban: getKanban(apiHttpClient),
    editMilestone: editMilestone(apiHttpClient),
    removeAllocation: removeAllocation(apiHttpClient),
    getProjectTasks: getProjectTasks(apiHttpClient, linker),
    getUserHumanResource: getUserHumanResource(apiHttpClient, linker),
    getMilestone: getMilestone(apiHttpClient),
    addTagToMilestone: addTagToMilestone(apiHttpClient),
    getPersonalSynthesis: getPersonalSynthesis(apiHttpClient),
    moveList: moveList(apiHttpClient),
    moveMilestone: moveMilestone(apiHttpClient),
    moveTask: moveTask(apiHttpClient),
    moveProjectElement: moveProjectElement(apiHttpClient),
    moveKanbanTask: moveKanbanTask(apiHttpClient),
    get: getCurrentPlanzone(apiHttpClient),
    removeTagFromList: removeTagFromList(apiHttpClient),
    removeTagFromMilestone: removeTagFromMilestone(apiHttpClient),
    removeTagFromTask: removeTagFromTask(apiHttpClient),
    getProjectsElementsTags: getProjectsElementsTags(apiHttpClient),
    getProjectsTags: getProjectsTags(apiHttpClient),
    getResourcesTags: getResourcesTags(apiHttpClient),
    getProjectResourcesTags: getProjectResourcesTags(apiHttpClient),
    saveProjectExternalLink: saveProjectExternalLink(apiHttpClient),
    getProjectExternalLinks: getProjectExternalLinks(apiHttpClient),
    removeProjectExternalLink: removeProjectExternalLink(apiHttpClient),
    editProjectExternalLink: editProjectExternalLink(apiHttpClient),
    getProjectStatuses: getProjectStatuses(apiHttpClient),
    saveProjectStatus: saveProjectStatus(apiHttpClient),
    updateProjectStatus: updateProjectStatus(apiHttpClient),
    removeProjectStatus: removeProjectStatus(apiHttpClient),
    saveResourceInProject: saveResourceInProject(apiHttpClient, linker),
    saveResourcesInProject: saveResourcesInProject(apiHttpClient, linker),
    saveEveryoneInProject: saveEveryoneInProject(apiHttpClient),
    saveResourceInProjects: saveResourceInProjects(apiHttpClient, linker),
    saveProfilePicture: saveProfilePicture(apiHttpClient, documentHttpClient),
    saveProjectResource: saveProjectResource(apiHttpClient, linker),
    removeResourceFromPlanzoneAndTransferAllocations:
      removeResourceFromPlanzoneAndTransferAllocations(apiHttpClient),
    removeResourceFromPlanzone: removeResourceFromPlanzone(apiHttpClient),
    getPersonalWeeklyCalendar: getPersonalWeeklyCalendar(apiHttpClient),
    editPersonalWeeklyCalendar: editPersonalWeeklyCalendar(apiHttpClient),
    editResourceWeeklyCalendar: editResourceWeeklyCalendar(apiHttpClient),
    editProjectReportTemplate: editProjectReportTemplate(apiHttpClient),
    getProjectReportTemplate: getProjectReportTemplate(apiHttpClient),
    saveProjectReport: saveProjectReport(apiHttpClient),
    updateProjectReport: updateProjectReport(apiHttpClient),
    getProjectReports: getProjectReports(apiHttpClient),
    removeProjectReport: removeProjectReport(apiHttpClient),
    updateProjectConfiguration: updateProjectConfiguration(apiHttpClient),
    getProjectConfiguration: getProjectConfiguration(apiHttpClient),
    editResource: editResource(apiHttpClient, linker),
    updatePlanzoneContacts: updatePlanzoneContacts(apiHttpClient),
    getPlanzoneRole: getPlanzoneRole(apiHttpClient, linker),
    getProjectRole: getProjectRole(apiHttpClient),
    getProjectsRoles: getProjectsRoles(apiHttpClient),
    getZoneRole: getZoneRole(apiHttpClient),
    editResourceGroup: editResourceGroup(apiHttpClient, linker),
    getResourceGroup: getResourceGroup(apiHttpClient, linker),
    getResourceGroups: getResourceGroups(apiHttpClient, linker),
    removeResourceGroup: removeResourceGroup(apiHttpClient),
    saveResourceGroup: saveResourceGroup(apiHttpClient),
    saveResourceInResourceGroup: saveResourceInResourceGroup(apiHttpClient),
    saveEveryoneInResourceGroup: saveEveryoneInResourceGroup(apiHttpClient),
    removeResourceFromResourceGroup:
      removeResourceFromResourceGroup(apiHttpClient),
    editProjectResource: editProjectResource(apiHttpClient, linker),
    saveEvent: (project, list, event) =>
      createDiscussion(apiHttpClient, () =>
        saveEvent(apiHttpClient, linker)(project, list, event),
      )("events"),
    addTagToProject: addTagToProject(apiHttpClient),
    removeTagFromProject: removeTagFromProject(apiHttpClient),
    removeMilestone: removeMilestone(apiHttpClient),
    getEvent: getEvent(apiHttpClient),
    editEvent: editEvent(apiHttpClient),
    removeEvent: removeEvent(apiHttpClient),
    addTagToResource: addTagToResource(apiHttpClient),
    removeTagFromResource: removeTagFromResource(apiHttpClient),
    addTagToEvent: addTagToEvent(apiHttpClient),
    removeTagFromEvent: removeTagFromEvent(apiHttpClient),
    updateOrganization: updateOrganization(uaaHttpClient),
    getPlanzoneOrganisation: getPlanzoneOrganisation(uaaHttpClient),
    getDiscussion: getDiscussion(apiHttpClient, linker),
    saveComment: saveComment(apiHttpClient),
    createDiscussion: addDiscussion(apiHttpClient),
    removeDiscussion: removeDiscussion(apiHttpClient),
    removeComment: removeComment(apiHttpClient),
    getDiscussions: getDiscussions(apiHttpClient),
    editPassword: editPassword(uaaHttpClient),
    getProjectPortfolios: getProjectPortfolios(apiHttpClient, linker),
    saveProjectPortfolio: saveProjectPortfolio(apiHttpClient),
    removeProjectPortfolio: removeProjectPortfolio(apiHttpClient),
    saveProjectInPortfolio: saveProjectInPortfolio(apiHttpClient),
    removeProjectFromPortfolio: removeProjectFromPortfolio(apiHttpClient),
    updateProjectPortfolio: updateProjectPortfolio(apiHttpClient),
    getProjectModels: getProjectModels(apiHttpClient, linker),
    duplicateProjectFromModel: duplicateProjectFromModel(apiHttpClient, linker),
    duplicateProject: duplicateProject(apiHttpClient, linker),
    duplicateModelFromProject: duplicateModelFromProject(apiHttpClient),
    isProjectPortfolioDuplicate: isProjectPortfolioDuplicate(),
    sendInvitation: sendInvitation(apiHttpClient),
    getNotifications: getNotifications(apiHttpClient),
    fillAccount: fillAccount(apiHttpClient),
    moveEvent: moveEvent(apiHttpClient),
    getUnReadNotificationsNbr: getUnReadNotificationsNbr(apiHttpClient),
    editNotificationsStatus: editNotificationsStatus(apiHttpClient),
    getDocuments: getDocuments(documentHttpClient),
    getPrivateDocuments: getPrivateDocuments(documentHttpClient),
    saveDocument: saveDocument(documentHttpClient),
    updateDocument: updateDocument(documentHttpClient),
    retrieveDocumentKey: retrieveDocumentKey(documentHttpClient),
    retrieveDocumentEditionToken: getDocumentEditionToken(apiHttpClient),
    saveFolder: saveFolder(documentHttpClient),
    updateFolder: updateFolder(documentHttpClient),
    removeFolder: removeFolder(documentHttpClient),
    removeDocument: removeDocument(documentHttpClient),
    attachDocumentsToElement: attachDocumentsToElement(apiHttpClient),
    retrieveElementAttachments: retrieveElementAttachments(
      apiHttpClient,
      documentHttpClient,
    ),
    moveDocument: moveDocument(documentHttpClient),
    moveFolder: moveFolder(documentHttpClient),
    copyDocument: copyDocument(documentHttpClient),
    retrieveDocumentTemplatesFolder:
      getDocumentTemplatesFolder(documentHttpClient),
    createDocument: createDocument(documentHttpClient),
    removeAttachedDocument: removeAttachedDocument(apiHttpClient),
    send: sendActivityReport(apiHttpClient),
    getProjectSynthesis: getProjectSynthesis(apiHttpClient),
    getProjectTimeSheet: getProjectTimeSheet(apiHttpClient),
    getTimeSheet: getTimeSheet(apiHttpClient),
    reloadProjectTimeSheet: reloadProjectTimeSheet(apiHttpClient),
    getOptimizedTimeSheet: getOptimizedTimeSheet(apiHttpClient),
    saveTimeRecord: saveTimeRecord(apiHttpClient),
    getWeekTimeRecords: getWeekTimeRecords(apiHttpClient),
    deleteTimeRecord: deleteTimeRecord(apiHttpClient),
    validateTimeRecords: validateTimeRecords(apiHttpClient),
    getProjectBudgetSynthesis: getProjectBudgetSynthesis(apiHttpClient),
    saveCostProfile: saveCostProfile(apiHttpClient),
    getCostProfiles: getCostProfiles(apiHttpClient),
    updateCostProfile: updateCostProfile(apiHttpClient),
    removeCostProfile: removeCostProfile(apiHttpClient),
    saveCostProfileAssignation: saveCostProfileAssignation(apiHttpClient),
    removeCostProfileAssignation: removeCostProfileAssignation(apiHttpClient),
    getWorkLoads: getWorkLoads(apiHttpClient),
    getCapacity: getCapacity(apiHttpClient),
    getWorkload: getWorkload(apiHttpClient),
    getWorkloadProjects: getWorkloadProjects(apiHttpClient),
    getOccupancy: getOccupancy(apiHttpClient),
    adjustWorkload: adjustWorkload(apiHttpClient),
    adjustCapacity: adjustCapacity(apiHttpClient),
    getCostProfileCostsHistory: getCostProfileCostsHistory(apiHttpClient),
    removeCost: removeCost(apiHttpClient),
    updateCost: updateCost(apiHttpClient),
    updateProjectAllocatedBudget: updateProjectAllocatedBudget(apiHttpClient),
    updateProjectAllocatedResourcesBudget:
      updateProjectAllocatedResourcesBudget(apiHttpClient),
    updateProjectAllocatedExpensesBudget:
      updateProjectAllocatedExpensesBudget(apiHttpClient),
    getPersonalTimeSheet: getPersonalTimeSheet(apiHttpClient),
    validatePersonalTimeRecords: validatePersonalTimeRecords(apiHttpClient),
    saveConstraint: saveConstraint(apiHttpClient),
    updateConstraint: updateConstraint(apiHttpClient),
    removeConstraint: removeConstraint(apiHttpClient),
    getElementConstraints: getElementConstraints(apiHttpClient),
    getConstraint: getConstraint(apiHttpClient),
    saveUnavailability: saveUnavailability(apiHttpClient),
    updateUnavailability: updateUnavailability(apiHttpClient),
    removeUnavailability: removeUnavailability(apiHttpClient),
    getUnavailabilityReasons: getUnavailabilityReasons(apiHttpClient),
    getUnavailabilities: getUnavailabilities(apiHttpClient),
    getPlanzoneSettings: getPlanzoneSettings(apiHttpClient),
    updatePlanzoneSettings: updatePlanzoneSettings(apiHttpClient),
    getStrategicAxes: getStrategicAxes(apiHttpClient),
    saveStrategicAxis: saveStrategicAxis(apiHttpClient),
    getOrganizationalUnits: getOrganizationalUnits(apiHttpClient),
    getAllOrganizationalUnits: getAllOrganizationalUnits(apiHttpClient),
    saveOrganizationalUnit: saveOrganizationalUnit(apiHttpClient),
    editOrganizationalUnit: editOrganizationalUnit(apiHttpClient),
    removeOrganizationalUnit: removeOrganizationalUnit(apiHttpClient),
    moveOrganizationalUnit: moveOrganizationalUnit(apiHttpClient),
    assignResourcesToOrganizationalUnit:
      assignResourcesToOrganizationalUnit(apiHttpClient),
    unassignResourcesFromOrganizationalUnit:
      unassignResourcesFromOrganizationalUnit(apiHttpClient),
    getAccessRestrictions: getAccessRestrictions(apiHttpClient),
    updateAccessRestrictions: updateAccessRestrictions(apiHttpClient),
    removeStrategicAxis: removeStrategicAxis(apiHttpClient),
    editStrategicAxis: editStrategicAxis(apiHttpClient),
    saveProjectStrategicAxis: saveProjectStrategicAxis(apiHttpClient),
    getProjectStrategicAxes: getProjectStrategicAxes(apiHttpClient),
    editProjectStrategicAxis: editProjectStrategicAxis(apiHttpClient),
    saveCalendarExportLink: saveCalendarExportLink(apiHttpClient),
    getCalendarExportLinks: getCalendarExportLinks(apiHttpClient),
    saveExportBiRun: saveExportBiRun(apiHttpClient),
    getExportBiRun: getExportBiRun(apiHttpClient),
    saveVideoConferenceCall: saveVideoConferenceCall(apiHttpClient),
    getVideoConferenceCallLinks: getVideoConferenceCallLinks(apiHttpClient),
    duplicateList: duplicateList(apiHttpClient, linker),
    getResourceProjects: getResourceProjects(apiHttpClient),
    getProjectExpenses: getProjectExpenses(apiHttpClient),
    saveProjectExpense: saveProjectExpense(apiHttpClient),
    getProjectExpenseTypes: getProjectExpenseTypes(apiHttpClient),
    saveProjectExpenseType: saveProjectExpenseType(apiHttpClient),
    removeProjectExpense: removeProjectExpense(apiHttpClient),
    editProjectExpense: editProjectExpense(apiHttpClient),
    getCalendar: getCalendar(apiHttpClient),
    assignManagerToResource: assignManagerToResource(apiHttpClient),
    unAssignManagerFromResource: unAssignManagerFromResource(apiHttpClient),
    assignEveryoneToManager: assignEveryoneToManager(apiHttpClient),
    removeSubordinates: removeSubordinates(apiHttpClient),
    getResourceSubordinates: getResourceSubordinates(apiHttpClient),
    getProjectResourcesListing: getProjectResourcesListing(apiHttpClient),
    getGantt: getGantt(apiHttpClient),
    getZoneGantt: getZoneGantt(apiHttpClient, linker),
    getProjectLogs: getProjectLogs(apiHttpClient),
    getSecondaryCriteriaTemplate: getSecondaryCriteriaTemplate(apiHttpClient),
    updateSecondaryCriteriaTemplate:
      updateSecondaryCriteriaTemplate(apiHttpClient),
    getWbsConfiguration: getWbsConfiguration(apiHttpClient),
    updateWbsConfiguration: updateWbsConfiguration(apiHttpClient),
    getProjectDetailsConfiguration:
      getProjectDetailsConfiguration(apiHttpClient),
    updateProjectDetailsConfiguration:
      updateProjectDetailsConfiguration(apiHttpClient),
    getProjectListingConfiguration:
      getProjectListingConfiguration(apiHttpClient),
    updateProjectListingConfiguration:
      updateProjectListingConfiguration(apiHttpClient),
    getResourcesListingConfiguration:
      getResourcesListingConfiguration(apiHttpClient),
    updateResourcesListingConfiguration:
      updateResourcesListingConfiguration(apiHttpClient),
    getTimeRecordsListingConfiguration:
      getTimeRecordsListingConfiguration(apiHttpClient),
    updateTimeRecordsListingConfiguration:
      updateTimeRecordsListingConfiguration(apiHttpClient),
    getProjectMembersListingConfiguration:
      getProjectMembersListingConfiguration(apiHttpClient),
    updateProjectMembersListingConfiguration:
      updateProjectMembersListingConfiguration(apiHttpClient),
    getProjectElementDetailsConfiguration:
      getProjectElementDetailsConfiguration(apiHttpClient),
    updateProjectElementDetailsConfiguration:
      updateProjectElementDetailsConfiguration(apiHttpClient),
    getResourceDetailsConfiguration:
      getResourceDetailsConfiguration(apiHttpClient),
    updateResourceDetailsConfiguration:
      updateResourceDetailsConfiguration(apiHttpClient),
    saveCalendarHolidays: saveCalendarHolidays(apiHttpClient),
    getCalendarsHolidays: getCalendarsHolidays(apiHttpClient),
    removeCalendarHolidays: removeCalendarHolidays(apiHttpClient),
    editCalendarHolidays: editCalendarHolidays(apiHttpClient),
    removeHoliday: removeHoliday(apiHttpClient),
    assignPersonalCalendarHolidays: assignPersonalCalendarHolidays(
      apiHttpClient,
      linker,
    ),
    unAssignPersonalCalendarHolidays: unAssignPersonalCalendarHolidays(
      apiHttpClient,
      linker,
    ),
    getPersonalCalendarHolidays: getPersonalCalendarHolidays(apiHttpClient),
    assignDefaultCalendarHolidaysToPlanzone:
      assignDefaultCalendarHolidaysToPlanzone(apiHttpClient),
    getDefaultCalendarHolidays: getDefaultCalendarHolidays(apiHttpClient),
    getResourceCalendarHolidays: getResourceCalendarHolidays(apiHttpClient),
    assignCalendarHolidaysToResource: assignCalendarHolidaysToRessource(
      apiHttpClient,
      linker,
    ),
    unAssignCalendarHolidaysFromResource: unAssignCalendarHolidaysFromResource(
      apiHttpClient,
      linker,
    ),
    getPlanzoneLogs: getPlanzoneLogs(apiHttpClient),
    disableProjectResource: disableProjectResource(apiHttpClient, linker),
    activateProjectResource: activateProjectResource(apiHttpClient, linker),
    disableResource: disableResource(apiHttpClient, linker),
    activateResource: activateResource(apiHttpClient, linker),
    getProjectResourceAllocations: getProjectResourceAllocations(apiHttpClient),
    saveIdentityProvider: saveIdentityProvider(apiHttpClient),
    getIdentityProviders: getIdentityProviders(apiHttpClient),
    removeIdentityProvider: removeIdentityProvider(apiHttpClient),
    updateIdentityProvider: updateIdentityProvider(apiHttpClient),
    editTimesheetDeadline: editTimesheetDeadline(apiHttpClient),
    updateAllocationWarningConfig: updateAllocationWarningConfig(apiHttpClient),
    checkAllocationWarnings: checkAllocationWarnings(apiHttpClient),

    getOptimizedGantt: getOptimizedGantt(apiHttpClient),
    getGanttCalendarRange: getGanttCalendarRange(apiHttpClient),
    getWbsMeta: getWbsMeta(apiHttpClient),
    getConstraints: getConstraints(apiHttpClient),
    getTasks: getTasks(apiHttpClient),

    submitChatJob: submitChatJob(aiHttpClient),
    getChatConversations: getChatConversations(aiHttpClient),
    getChatConversationMessages: getChatConversationMessages(aiHttpClient),
    removeChatConversation: removeChatConversation(aiHttpClient),
    cancelChatJob: cancelChatJob(aiHttpClient),
    resetChatMemory: resetChatMemory(aiHttpClient),
  };
}

export type { Service, HttpClient, RequestConfig };

export { createService, HttpMethods };
export { createDateOps } from "./utils/dateOps";
export { createStreamChatJob } from "./chatbot/streamChatJob";
